import { observer } from 'mobx-react-lite'
import { UndoButton } from './UndoButton'
import { RedoButton } from './RedoButton'
import {
  DropdownOrchestrationContext,
  DropdownOrchestrationStore,
} from 'common/Prose/Toolbar/ToolbarBravo/stores/DropdownOrchestrationStore'
import Styles from './WriterFormatToolbar.module.scss'
import { ClearFormattingButton } from './ClearFormattingButton'
import { TextStyleDropdown } from 'common/Prose/Toolbar/ToolbarBravo/TextStyleDropdown/TextStyleDropdown'
import { ShowFor } from 'common/Prose/Toolbar/ToolbarBravo/ResponsiveShowHide'
import { ListsOptions } from 'common/Prose/Toolbar/ToolbarBravo/ListsGroup/ListsOptions'
import { ListsDropdown } from 'common/Prose/Toolbar/ToolbarBravo/ListsGroup/ListsDropdown'
import { InlineTextColorButton } from 'common/Prose/Toolbar/ToolbarBravo/InlineTextColorButton'
import { InlineHighlightColorButton } from 'common/Prose/Toolbar/ToolbarBravo/DoubleActionButtons/InlineHighlightColorButton'
import { CalloutButton } from 'common/Prose/Toolbar/ToolbarBravo/DoubleActionButtons/CalloutButton'
import { QuoteButton } from 'common/Prose/Toolbar/ToolbarBravo/DoubleActionButtons/QuoteButton'
import { AlignmentDropdown } from 'common/Prose/Toolbar/ToolbarBravo/AlignmentGroup/AlignmentDropdown'
import { InsertDropdown } from 'common/Prose/Toolbar/ToolbarBravo/InsertDropdown/InsertDropdown'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const WriterFormatToolBar = observer(() => {
  const { isMobile } = useResponsiveDesign()

  return (
    <DropdownOrchestrationContext.Provider value={new DropdownOrchestrationStore()}>
      <div className={Styles.leftButtons}>
        <div className={Styles.buttonGroup}>
          <UndoButton />
          <RedoButton />
          <ClearFormattingButton />
        </div>
      </div>

      {!isMobile && (
        <>
          <div className={Styles.buttonGroup}>
            <ShowFor sceneA sceneB sceneC sceneD toolbar>
              <TextStyleDropdown />
              <ShowFor sceneD toolbar>
                <ListsOptions />
              </ShowFor>
              <ShowFor sceneA sceneB sceneC toolbar>
                <ListsDropdown />
              </ShowFor>
              <InlineTextColorButton />
              <InlineHighlightColorButton />
              <CalloutButton />
              <QuoteButton />
              <AlignmentDropdown />
            </ShowFor>
          </div>

          <div className={Styles.rightButtons}>
            <div className={Styles.buttonGroup}>
              <InsertDropdown />
            </div>
          </div>
        </>
      )}
    </DropdownOrchestrationContext.Provider>
  )
})
